// src/components/store/sections/faqs/FaqV99TicketfaqSunsetAmber.tsx
"use client";

import React from "react";
import DynamicFaqVariant from "./DynamicFaqVariant";

export default function FaqV99TicketfaqSunsetAmber(props: any) {
  return (
    <DynamicFaqVariant
      variantNumber={99}
      archKey="ticket_faq"
      archLabel="Perforated Ticket Q&A"
      palName="SunsetAmber"
      grad="from-amber-500 via-orange-500 to-red-600"
      lightBg="bg-amber-50"
      textCol="text-amber-800"
      borderCol="border-amber-200"
      btnCls="bg-orange-600 hover:bg-orange-700"
      hexCol="#f59e0b"
      {...props}
    />
  );
}
